import Icon from '@components/common/Icon';
import CloseBtn from '@components/common/buttons/CloseBtn';
import Modal from '@components/modal/Modal';
import useModalHook from '@hooks/useModalHook';
import strings from '@i18n/index';
import useCurrentChannel from '@stores/currentChannelStore';
import useThemeStore from '@stores/themeStore';
import * as SC from '@views/channelSettings/EditChannelNameModal.style';
import { cloneDeep } from 'lodash-es';
import { useState } from 'react';

export const EditChannelNameModalLabel = 'editChannelNameModal';

export type EditChannelNameModalProps = { defaultChannelName: string };

const EditChannelNameModal = ({ defaultChannelName }: EditChannelNameModalProps) => {
  const { theme } = useThemeStore();
  const { closeModal } = useModalHook();
  const { currentChannel, setCurrentChannel } = useCurrentChannel();
  const [channelName, setChannelName] = useState(defaultChannelName);

  const confirm = async () => {
    const result = await currentChannel?.updateChannel({
      name: channelName,
    });

    if (result) {
      // MARK ::: object 값 변경 감지 위한 깊은 복사
      setCurrentChannel(cloneDeep(result));
    }

    closeModal('editChannelNameModal');
  };

  return (
    <Modal
      width='480px'
      title={strings.CHANNEL__EDIT_CHANNEL_NAME}
      onCancel={() => {
        closeModal('editChannelNameModal');
      }}
      onConfirm={confirm}
      subChildren={
        <CloseBtn>
          <Icon icon='CloseIcon' size='22px' color={theme === 'dark' ? '#fff' : '#333'} />
        </CloseBtn>
      }
      onSubAction={() => {
        closeModal('editChannelNameModal');
      }}
      disabled={defaultChannelName === channelName}
    >
      <SC.Wrapper>
        <SC.ChannelNameText>{strings.SENDBIRD.MODAL__CHANNEL_INFORMATION__CHANNEL_NAME}</SC.ChannelNameText>
        <SC.InputWrapper>
          <SC.Input
            isDark={theme === 'dark'}
            value={channelName}
            onChange={(e) => {
              setChannelName(e.target.value);
            }}
            autoFocus
          />
        </SC.InputWrapper>
        <SC.Guide>* {strings.CHANNEL__EDIT_CHANNEL_NAME_GUIDE}</SC.Guide>
      </SC.Wrapper>
    </Modal>
  );
};

export default EditChannelNameModal;
